import { jsx } from "react/jsx-runtime";
import { Box } from "../../Box/Box.mjs";
import { IconContainer } from "../IconContainer.mjs";
import { IconMobileSvg } from "./IconMobileSvg.mjs";
const IconMobile = (props) => /* @__PURE__ */ jsx(IconContainer, { ...props, children: (svgProps) => /* @__PURE__ */ jsx(Box, { component: IconMobileSvg, ...svgProps }) });
export {
  IconMobile
};
